module.exports = __webpack_public_path__ + "static/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917-2928664fe1fc6aca88583a6f606d60ba.svg";